import * as yup from "yup";

const {
  setLocale
} = yup

setLocale({
  mixed: {
    // notType: 'the ${path} is obligatory',
    required: 'at least one field is required',
    // oneOf: 'the field ${path} must have one of the following values: ${values}'
  }
});

// Yup schema for field validations
export const FindReservationSchema = yup.object().shape({
  email: yup.string().ensure().when('itineraryNumber', {
    is: '',
    then: yup.string().required()
  }),
  itineraryNumber: yup.string().ensure().when('email', {
    is: '',
    then: yup.string().required()
  }),
}, [["email", "itineraryNumber"]]);

export type FindReservationFormData = yup.InferType<typeof FindReservationSchema>;

export const FindReservationSchemaDefaultValues: FindReservationFormData = {
  email: "",
  itineraryNumber: "",
};
